<script>
import { mergeData } from "vue-functional-data-merge";
import { typographyColorValidator } from "../enumValidator";

export default {
  functional: true,
  props: {
    /**
     * Sets icon (https://material.io/resources/icons/)
     */
    icon: {
      type: String,
      required: true
    },
    /**
     * ["inherit", "text", "medium", "disabled", "primary", "positive", "negative", "on-primary"]
     */
    color: {
      type: String,
      validator: typographyColorValidator,
      default: "inherit"
    }
  },
  render: function(createElement, context) {
    const { props, data } = context;

    return createElement(
      "i",
      mergeData(data, {
        class: ["material-icons", `am-typography--color-${props.color}`]
      }),
      `${props.icon}_24px`
    );
  }
};
</script>
